import { render, staticRenderFns } from "./my-coupon-own-list.vue?vue&type=template&id=59a7f8d4&scoped=true&"
import script from "./my-coupon-own-list.vue?vue&type=script&lang=js&"
export * from "./my-coupon-own-list.vue?vue&type=script&lang=js&"
import style0 from "./my-coupon-own-list.vue?vue&type=style&index=0&id=59a7f8d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a7f8d4",
  null
  
)

export default component.exports